/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { useSelector } from 'react-redux';
import { getActiveSku, getSkus } from '../../../selectors/productPage';
import { getCartItems } from '../../../selectors/cart';
import PromoLabel from '../../my-puratos/molecules/promotions/PromoLabel';
import { useEffect, useState } from 'react';
import { getGTMInteractionCrossSell } from '../../../selectors/analytics';
import {
    calculateDiscount,
    hasDiscount,
    formatStringNumber
} from '../../../analytics/ga4/utils/helpers';

const promoLabelRoot = document.getElementById('react-promo--hero-label');

function HeaderPromoLabel({productCategoryTag}) {
    const activeProducts = useSelector((state) => getSkus(state));
    const cartItems = useSelector((state) => getCartItems(state));
    const activeProduct = useSelector((state) => getActiveSku(state));
    const [analyticsData, setAnalyticsData] = useState();
    const crossSellBlock = useSelector((state) => getGTMInteractionCrossSell(state, activeProduct?.materialNumber));

    const promoAnalyticsData = function(activeItem) {
        try {
            const {
                promoCode,
                promoText,
                materialNumber,
                packaging,
                salesUnit,
                unitPriceDouble,
                aemProdName,
                currency,
                baseUnit
            } = activeItem || {};

            // productCategoryTag e.g. "belgium:products/categories/chocolade/Specialiteit"
            const categoryStringArray = productCategoryTag?.split('products/categories/');
            const categoryString = categoryStringArray?.length > 1 ? categoryStringArray[1] : '';
            const categoryArray = categoryString?.split('/');
            const item_category = categoryArray?.length > 0 ? categoryArray[0] : '';
            const item_category2 = categoryArray?.length > 1 ? categoryArray[1] : '';

            const quantity = cartItems
                ?.filter(item => item?.materialNumber === materialNumber)
                .reduce((sum, item) => sum += item.quantity, 0);

            const data = {
                promotion_id: promoCode,
                promotion_name: promoText,
                website_section: 'Product page', // GA4PageType.product
                item_brand: 'Puratos',
                crosssell_block: crossSellBlock ?? '',
                item_list_name: 'pdp-add-to-cart', // GA4ComponentType.PDP_ADD_TO_CART
                item_name: aemProdName,
                item_id: materialNumber?.toString(),
                item_variant: salesUnit
                ? `${salesUnit} ${formatStringNumber(packaging)} ${
                      baseUnit
                  }`
                : packaging,
                index: '1',
                quantity: quantity ?? 0,
                price: unitPriceDouble ?? '',
                discount: hasDiscount(activeItem) ? calculateDiscount(activeItem) : '',
                currency,
                item_category,
                item_category2
            };
            setAnalyticsData(data);
        } catch (e) {
            console.warn('Analytics error', e);
        }
    };

    useEffect(() => {
        if (activeProduct) {
            promoAnalyticsData(activeProduct);
        }
    }, [activeProduct]);

    if (!activeProduct || !promoLabelRoot) {
        return null;
    }

    if (activeProduct?.promoCode) {
        return ReactDOM.createPortal(
            <PromoLabel
                product={activeProduct}
                analyticsData={analyticsData}
                placement={'auto'}
            />,
            promoLabelRoot
        );
    }

    const promotionProduct = activeProducts.find(
        (product) => !!product.promoCode
    );

    if (promotionProduct) {
        return ReactDOM.createPortal(
            <PromoLabel
                product={promotionProduct}
                analyticsData={analyticsData}
                placement={'auto'}
            />,
            promoLabelRoot
        );
    }

    return null;
}

export default HeaderPromoLabel;
